var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { IsEnum, IsOptional, IsString } from "class-validator";
import { BaseUserDto, UserType } from "./user.dtos";
export class ExternalResearcherUserDto extends BaseUserDto {
    constructor(fields) {
        super();
        this.type = UserType.EXTERNAL_RESEARCHER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], ExternalResearcherUserDto.prototype, "type", void 0);
export class ExternalResearcherUserForAuthenticationDto extends ExternalResearcherUserDto {
}
__decorate([
    IsString(),
    IsOptional()
], ExternalResearcherUserForAuthenticationDto.prototype, "hashedPassword", void 0);
export class InviteExternalResearcherUserInput extends PickType(ExternalResearcherUserDto, ["type", "email", "permissions"]) {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
export class CreateExternalResearcherUserInput extends OmitType(ExternalResearcherUserDto, [
    "id",
    "organizationId",
    "passwordExpiresAt",
    "passwordUpdatedAt",
    "loginFailureCount",
    "statusUntil",
    "accountStatus",
]) {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
export class UpdateExternalResearcherUserInput extends PartialType(CreateExternalResearcherUserInput) {
    constructor(fields) {
        super();
        this.type = UserType.EXTERNAL_RESEARCHER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], UpdateExternalResearcherUserInput.prototype, "type", void 0);
